import { BaseFactory } from 'src/services/entity-factory/FactoryInterface';
import InvestorType from 'src/entities/InvestorType';

export interface ApiInvestorTypeResponse {
  investorType: {
    type: string;
    confirmed: boolean;
    acceptedRisks: boolean | null;
    accreditationExpired: boolean | null;
  };
}

interface ApiInvestorTypeCreateRequest {
}

export class InvestorTypeFactory extends BaseFactory<InvestorType> {
  public toEntity(args: ApiInvestorTypeResponse): InvestorType {
    return new InvestorType({
      type: args.investorType.type,
      confirmed: args.investorType.confirmed,
      acceptedRisks: args.investorType.acceptedRisks || undefined,
      accreditationExpired: args.investorType.accreditationExpired || undefined,
    });
  }

  public toRequest(investorType: InvestorType): ApiInvestorTypeCreateRequest {
    return {
      type: investorType.type,
      confirmationMessage: investorType.confirmationMessage,
      acceptedRisks: investorType.acceptedRisks,
      filledAptitudeTestId: investorType.filledAptitudeTestId,
    };
  }
}


// WEBPACK FOOTER //
// ./src/services/entity-factory/factories/InvestorTypeFactory.tsx